export enum TimeUnitSingular {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  NEVER = 'never',
}
